import * as z from "zod";

const paginationShape = {
	limit: z.number().int().min(1).max(100).default(25),
	offset: z.number().int().nonnegative().default(0),
};

export const listInput = <TFilters extends z.ZodRawShape>(filters: TFilters) =>
	z.strictObject({
		...filters,
		...paginationShape,
	});

export const listData = <TItem extends z.ZodType>(item: TItem) =>
	z.strictObject({
		items: z.array(item),
		total: z.number().int().nonnegative(),
	});

export const page = <T>(
	rows: T[],
	total: number,
	input: { limit: number; offset: number },
): {
	data: { items: T[]; total: number };
	truncated?: { shown: number; total: number };
} => {
	const items = rows.slice(0, input.limit);
	const shown = input.offset + items.length;
	return {
		data: { items, total },
		...(shown < total ? { truncated: { shown, total } } : {}),
	};
};
